<template>
	<div class="pages">
		<div class="box" :style="{ height: height + 'px' }">
			<div class="left"></div>
			<div class="right">
				<p class="title">Account login</p>
				<li class="li">
					<img src="../../assets/user.png" alt="" />
					<input
						type="text"
						v-model="phone"
						@keyup.enter="grtLogin"
						placeholder="Please enter your mobile number/email address"
					/>
				</li>
				<li class="li">
					<img src="../../assets/password.png" alt="" />
					<input
						type="password"
						v-model="password"
						@keyup.enter="grtLogin"
						placeholder="Please input a password"
					/>
					<img
						v-if="password.length > 0"
						@click="password = ''"
						src="../../assets/del.png"
						alt=""
					/>
				</li>
				<p class="text">
					<router-link to="/register">register</router-link>
					<router-link to="/forget">Forgot your password?</router-link>
				</p>
				<p class="xieyi">
					By logging in, you agree to our
					<router-link :to="{ path: '/agreement', query: { type: 2 } }">
						service agreement
					</router-link>
					and
					<router-link :to="{ path: '/agreement', query: { type: 1 } }">
						privacy policy
					</router-link>
				</p>
				<p class="btn" @click="grtLogin">Sign in</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'login',
	data() {
		return {
			height: '',
			phone: '',
			password: ''
		};
	},
	created() {
		this.height = window.innerHeight;
	},
	methods: {
		grtLogin() {
			let data = {
				account: this.phone,
				password: this.$md5(this.password)
			};
			this.$api.login(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					sessionStorage.setItem('uid', res.data.uid);
					let that = this;
					that.getInfo(res.data.uid);
					that.$message({
						message: 'Login succeeded',
						type: 'success',
						center: true,
						duration: 1000,
						onClose: function() {
							that.$router.push({ path: '/index' });
						}
					});
				} else {
					this.$message({
						message: res.resultNote,
						type: 'error',
						center: true,
						duration: 1000
					});
				}
			});
		},
		// 获取个人信息
		getInfo(uid) {
			let data = {
				uid: uid
			};
			this.$api.info(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					sessionStorage.setItem('infoList', JSON.stringify(res.data));
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.pages {
	background: #000;
	.box {
		display: flex;
		align-items: center;
		.left {
			width: 60%;
			height: 100%;
			background-image: url(../../assets/bg.png);
			background-size: cover;
		}
		.right {
			width: 600px;
			height: 800px;
			background-image: url('../../assets/login.png');
			background-size: 100% 100%;
			padding: 120px 40px;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
			.title {
				font-size: 30px;
				color: #13fffc;
			}
			.li {
				width: 100%;
				height: 80px;
				border-bottom: 1px solid #13fffc;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				img {
					width: 16px;
					height: 16px;
					display: block;
					margin-right: 10px;
				}
				input {
					width: 100%;
					height: 79px;
					background: #060c18;
					border: none;
					font-size: 20px;
					outline: none;
					color: #13fffc;
					padding: 0 10px;
					box-sizing: border-box;
				}
			}
			.text {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				a {
					color: #13fffc;
					font-size: 20px;
				}
			}
			.xieyi {
				display: flex;
				flex-wrap: wrap;
				color: #0a7879;
				line-height: 30px;
				font-size: 20px;
				a {
					color: #13fffc;
					margin: 0 5px;
					font-size: 20px;
				}
			}
			.btn {
				width: 100%;
				height: 60px;
				background: linear-gradient(90deg, #1dafaa 0%, #23fef6 100%);
				text-align: center;
				line-height: 60px;
				font-size: 20px;
				font-family: SourceHanSansCN;
				font-weight: 400;
				color: #f6f6f6;
			}
		}
	}
}
</style>
